import {AxiosService} from './axiosService';

export class AuthService extends AxiosService {
  async login(email, password) {
    try {
      const {data} = await this.axios.post('/user_token', {
        email,
        password,
      });
      return data;
    } catch (e) {
      if (e?.response?.status) {
        return {error: e.response.status, message: e.response.statusText};
      } else {
        return null;
      }
    }
  }
  async get_user() {
    try {
      const {data} = await this.axios.get('/me');
      return data;
    } catch (e) {
      if (e?.response?.status) {
        return {error: e.response.status};
      } else {
        return null;
      }
    }
  }
  async signup(email, firstName, lastName, companyName, phone, address, city, state, zip, marketplaceToken = null) {
    try {
      const {data} = await this.axios.post('/signup', {
        email,
        firstName,
        lastName,
        companyName,
        phone,
        address,
        city,
        state,
        zip,
        marketplaceToken,
      });
      return data;
    } catch (e) {
      if (e?.response?.status) {
        return {error: e.response.status, message: e.response.statusText, errors: e.response.data?.errors};
      } else {
        return null;
      }
    }
  }

  async resolveMarketplaceToken(token) {
    try {
      const {data} = await this.axios.post('/marketplace/resolve', {
        token,
      });
      return data;
    } catch (e) {
      if (e?.response?.status) {
        return {error: e.response.status, message: e.response.statusText, errors: e.response.data?.errors};
      } else {
        return null;
      }
    }
  }
}

export const authService = new AuthService();
